import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "font-medium text-gray-600" }
const _hoisted_3 = { class: "group relative" }
const _hoisted_4 = { class: "invisible absolute left-0 top-full z-10 mt-1 w-48 rounded bg-gray-800 px-2 py-1 text-xs text-white group-hover:visible" }
const _hoisted_5 = { class: "sm:col-span-12" }
const _hoisted_6 = { class: "mb-2 block text-sm font-medium text-gray-800" }
const _hoisted_7 = { class: "mt-6 grid grid-cols-2 place-content-around gap-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiNode = _resolveComponent("UiNode")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiNode, {
      nodeId: $props.node.id,
      title: _ctx.$t('connectFlow.node.transferVirtualAgent.title'),
      icon: $setup.IconRobot,
      showActions: "",
      onEditNode: _cache[0] || (_cache[0] = ($event: any) => ($setup.showForm = true)),
      onRemoveNode: $setup.removeNode,
      class: _normalizeClass($setup.isFormCorrect ? '' : 'border-red-300 shadow-red-300')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString($setup.nodeText), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_3, [
            _createVNode($setup["QuestionMarkCircleIcon"], { class: "h-5 w-5 cursor-help text-gray-400 hover:text-gray-600" }),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('connectFlow.node.transferVirtualAgent.tooltip')), 1 /* TEXT */)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sourceOptionHandles, (handleId, idx) => {
          return (_openBlock(), _createBlock($setup["Handle"], {
            key: handleId,
            id: handleId,
            type: "source",
            connectable: false,
            position: $setup.Position.Bottom,
            style: _normalizeStyle(`left: ${(idx + 1) * (100 / ($setup.sourceOptionHandles.length + 1))}%; bottom: -6px`)
          }, null, 8 /* PROPS */, ["id", "position", "style"]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createVNode($setup["Handle"], {
          id: "hangupWithoutTransfer",
          type: "source",
          connectable: false,
          position: $setup.Position.Left,
          style: {"top":"auto","bottom":"30px"}
        }, null, 8 /* PROPS */, ["position"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["nodeId", "title", "icon", "class"]),
    _createVNode(_component_UiRightPanel, {
      modelValue: $setup.showForm,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.showForm) = $event)),
      title: _ctx.$t('connectFlow.node.transferVirtualAgent.title'),
      icon: $setup.IconRobot
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          autocomplete: "off",
          class: "flex flex-col gap-3",
          onSubmit: _withModifiers($setup.onSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('connectFlow.node.transferVirtualAgent.selectNumber')), 1 /* TEXT */),
            _createVNode(_component_UiMultiselect, {
              name: "number",
              modelValue: $setup.v$.number.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.v$.number.$model) = $event)),
              options: $setup.numberOptions,
              errors: $setup.v$.number.$silentErrors,
              label: "number",
              "value-prop": "id",
              "can-clear": ""
            }, null, 8 /* PROPS */, ["modelValue", "options", "errors"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_UiButton, {
              variant: "white",
              "text-variant": "gray-700",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showForm = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Cancel')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_UiButton, {
              type: "submit",
              variant: "primary",
              "text-variant": "white"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ], 32 /* NEED_HYDRATION */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "title", "icon"])
  ], 64 /* STABLE_FRAGMENT */))
}